// src/components/LoginScreen.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom'; 
import './LoginScreen.css';
import Tooltip from './Tooltip';

export default function LoginScreen({ 
  handleLogin, 
  loginError, 
  setUiState,
  initialEmail = "",
  initialPassword = "",
  overlay = null,
  reviewer = {},
}) {

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState(initialPassword);
  console.log("Overlay prop:", overlay);


  return (
    <div className="login-wrapper">
      <div className="login-screen">

        {reviewer.badge && (
          <div className="reviewer-badge">
            <i className={`${reviewer.badgeIcon} reviewer-icon`}></i>    
            <span className="hello-text">{reviewer.badgeText}</span>
          </div>
        )}

        <h2>Login</h2>

        {overlay && (
          <p className="login-overlay" style={{ marginBottom: "1rem", color: "#555" }}>
            {overlay}
          </p>
        )}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            const email = e.target.email?.value;
            const password = e.target.password?.value;
            handleLogin(email, password);
          }}
        >
          <Tooltip text={reviewer?.loginHint ? `${reviewer.badge}:Login with your prepopulated credentials` : ""}>
            <input 
              name="email" 
              type="email" 
              placeholder="Email" 
              required 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </Tooltip>  
         {/* <input name="password" type="password" placeholder="Password" required /> */}
          <div className="input-with-icon">
              <input
                name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field"
                autoComplete="current-password"
              />
              <i
                className={`fa-regular ${showPassword ? 'fa-eye' : 'fa-eye-slash' } toggle-icon`}
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label="Toggle password visibility"
              />
          </div>

          <button type="submit" >Login</button>
        </form>

        <p className="reset-link">
          <Link
            to="/forgot-password"
            style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer' }}
          >
            Forgot your password?
          </Link>
        </p>

        <p className="register-link">
            Don’t have an account?{' '}
            <a
                href="#"
                onClick={(e) => {
                e.preventDefault();
                setUiState('register');
                }}
                style={{ color: '#007bff', textDecoration: 'none', cursor: 'pointer' }}
            >
                Register here
            </a>
        </p>

        {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
      </div>
    </div>
  );
}
